import {useState} from "react";
import { createRoot } from "react-dom/client";

export const ModalPrompt = ({ message, onConfirm, onCancel }) => {
  const [value, setValue] = useState("");

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
      onClick={onCancel}
    >
      <div
        className="bg-white p-6 rounded-2xl w-80 shadow-lg z-50 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4">{message}</h2>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full text-black border p-2 rounded mb-4 text-black"
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={() => onCancel()}
            className="px-4 py-2 rounded"
          >
            Отмена
          </button>
          <button
            onClick={() => onConfirm(value)}
            className="px-4 py-2 rounded"
          >
            ОК
          </button>
        </div>
      </div>
    </div>
  );
};

export function openModalPrompt(message) {
  return new Promise((resolve, reject) => {
    const modalRoot = document.createElement("div");
    document.body.appendChild(modalRoot);
    const root = createRoot(modalRoot);

    const handleConfirm = (value) => {
      root.unmount();
      document.body.removeChild(modalRoot);
      resolve(value);
    };

    const handleCancel = () => {
      root.unmount();
      document.body.removeChild(modalRoot);
      reject(null); // Возвращаем null при отмене
    };

    root.render(
      <ModalPrompt message={message} onConfirm={handleConfirm} onCancel={handleCancel} />
    );
  });
}
